import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import CustomizedSnackbars from "../../components/snackbar/Snackbar";
import { useAppSelector } from "../../store/hooks/hook";
import ContentHeader from "./ContentHeader";
import { selectDataLoadComplete } from "../../store/slices/Auth/AuthSelector";
import { useSelector } from "react-redux";

//Layout Components
import AppHeader from "./header/AppHeader";
import Navbar from "./navbar/Navbar";
import AppFooter from "./footer/AppFooter";
import PageLoader from "../../components/loader/PageLoader";
import AppLoader from "../../components/loader/AppLoader";
import { useDebounce } from "../../helpers/utils/useDebounce";

//Layout used for Authorized Users
const AppLayout = () => {
  const loadComplete = useSelector(selectDataLoadComplete);

  const { navMode, defaultPage, loading } = useAppSelector((state) => ({
    navMode: state.reducer.Layout.navMode,
    defaultPage: state.reducer.Layout.defaultPath,
    loading: state.reducer.Layout.loading
  }));

  const [hide, setHide] = useState<boolean>(false);

  //Wait to make sure loading doesnt change. This would happen for multiple http request calls in quick succession. 
  const loadingdebounced = useDebounce(loading, 10);

  useEffect(() => {
    if (window.location.pathname.includes("/print") && !window.location.pathname.includes("/config")) {
      setHide(true);
    }

  }, []);

  if(!loadComplete) {
    return <></>
  }

  return (
    <React.Fragment>
      <div className="app-wrapper">
        <AppLoader loading={loadingdebounced} />
        {!hide && (
          <>
            <AppHeader navMode={navMode} />
            <Navbar type={navMode} />
          </>
        )}
        <div className={`app-content ${hide && "expand-content"} `}>
          <PageLoader loading={loadingdebounced} />
          <ContentHeader hide={hide} />
          <CustomizedSnackbars />
          <Outlet />
          <AppFooter hide={hide}/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AppLayout;
